import React, { useState } from 'react'
import { withPlugin } from '@flamingo_tech/funkgo'
import styles from './CartPageSoldOutList.module.css'
import cx from '../../../utils/className'
import ProductSliderList from './ProductSliderList'
import Pressable from '../../common/Pressable/Pressable'

const CartPageSoldOutList = props => {
  const [offSaleVisible, setOffSaleVisible] = useState(false)

  if (!props.unsaleableLineItems.length) {
    return null
  }

  const renderList = (items, isDesktop) => {
    if (!offSaleVisible) {
      return null
    }

    return (
      <ProductSliderList
        items={items}
        isDesktop={isDesktop}
      />
    )
  }

  return (
    <div className={cx(styles.wrapper, props.noBorder && styles.noBorder, props.isDesktop && styles.isDesktop)}>
      <div className={styles.unsaleableLineItems}>
        <div className={styles.header}>
          <Pressable
            className={styles.headerToggle}
            onClick={() => setOffSaleVisible(x => !x)}
            ariaLabel={props.$i18n.transl('core.cart.toggleSoldOutSection')}
            aria-expanded={offSaleVisible}
          >
            <div>
              <span>{props.$i18n.transl('core.cart.outOfStockItem', { count: props.unsaleableLineItems.length })}{`(${props.unsaleableLineItems.length})`}</span>
              <span className={cx(styles.unsaleIcon, offSaleVisible && styles.active)} aria-hidden="true">&#xe7b2;</span>
            </div>
          </Pressable>
          {offSaleVisible && (
            <Pressable
              className={styles.clearBtn}
              onClick={props.onClearExpireItems}
              ariaLabel={props.$i18n.transl('core.cart.clearSoldOut')}
            >{props.$i18n.transl('common.clearAll')}</Pressable>
          )}
        </div>
        {renderList(props.unsaleableLineItems, props.isDesktop)}
      </div>
    </div>
  )
}

export default withPlugin(CartPageSoldOutList)
